export const percentage = (partial: number, total: number) =>
  Math.round((partial / total) * 100);
